module.exports = __webpack_public_path__ + "static/media/img-kakao-banner@3x.c7ee045c.png";